import { compareDates, getToday } from 'helpers/date';

import { UpcomingProduct } from 'types/product';
import { ISubscription } from 'types/subscription';

const getUpcomingProduct = (subscription: ISubscription): UpcomingProduct | null => {
    const { product, upcoming_product, is_trial, expired_date, subscription_period } = subscription;

    if (upcoming_product && compareDates(upcoming_product.started_from, getToday()) > 0) {
        return upcoming_product;
    }

    if (is_trial) {
        return {
            started_from: expired_date,
            price: product?.price,
            currency: product?.currency,
            subscription_period: subscription_period,
        };
    }

    return null;
};

export default getUpcomingProduct;
